
import axios from 'axios';

// app config
import AppConfig from 'Constants/AppConfig';
import AuthHeader from 'Constants/AuthHeader';

import { NotificationManager } from 'react-notifications';
import {
   ALL_FEATURES,
   ADD_FEATURE,
   FEATURE_ACTION,
   EDIT_FEATURE,
   STATUS_FEATURE,
   DELETE_FEATURE,
   ALL_MENUS,
   ADD_MENU,
   MENU_ACTION,
   EDIT_MENU,
   STATUS_MENU,
   DELETE_MENU
} from 'Actions/types';

/**
 * Menu access Action
 */
export const allFeatures = () =>{
    
    
    return (dispatch) => { 
        dispatch({ type: FEATURE_ACTION });
        return axios.get(AppConfig.apiurl+'/api/getfeature', { headers: AuthHeader.header })         
        .then(response => {             
            const allroles=response.data.data;
            dispatch({ type: ALL_FEATURES, payload: allroles });
        });
    }
    

}

export const addFeature = (name) => async (dispatch) => {
    
    var payload={
        "name":name
     }
     dispatch({ type: FEATURE_ACTION });
    return axios.post(AppConfig.apiurl+'/api/addfeature', payload, { headers: AuthHeader.header })
     .then( response => {       
         if(response.status==200){ 
            var resdata=response.data;
            if(resdata.status===1){
               allFeatures()(dispatch);
               NotificationManager.success(resdata.message);               
               dispatch({ type: ADD_FEATURE });
            }else{
               NotificationManager.error(resdata.message); 
            }
            return Promise.resolve(resdata);
         }else{
            NotificationManager.error('Feature not added');
         }          
         
     })
     .catch( error => { 
       NotificationManager.error(error);
     });
}

export const editFeature = (data, role, id) => async (dispatch) => {
    
    var payload={
        "id":id,
        "name":data.target.name.value,
        "roleid":role,
        "display":data.target.display.value,
     }
     dispatch({ type: FEATURE_ACTION });
    return axios.post(AppConfig.apiurl+'/api/editfeature', payload, { headers: AuthHeader.header })
     .then( response => {       
         if(response.status==200){ 
            var resdata=response.data;
            if(resdata.status===1){
               allFeatures()(dispatch);
               NotificationManager.success(resdata.message);               
               dispatch({ type: EDIT_FEATURE });
            }else{
               NotificationManager.error(resdata.message); 
            }
            return Promise.resolve(resdata);
         }            
         
     })
     .catch( error => { 
       NotificationManager.error(error);
     });
}

export const statusFeature = (id,status) => async (dispatch) => {
    
    var payload={
        "id":id,
        "status":status
     }
     dispatch({ type: FEATURE_ACTION });
    axios.post(AppConfig.apiurl+'/api/statusfeature', payload, { headers: AuthHeader.header })
     .then( response => {       
         if(response.status==200){ 
            var resdata=response.data;
            if(resdata.status===1){
               allFeatures()(dispatch);
               NotificationManager.success(resdata.message);               
               dispatch({ type: STATUS_FEATURE });
            }else{
               NotificationManager.error(resdata.message); 
            }
         }            
         
     })
     .catch( error => { 
       NotificationManager.error(error);
     });
}

export const deleteFeature = (id) => async (dispatch) => {
    
    var payload={
        "id":id
     }
     dispatch({ type: FEATURE_ACTION });
    axios.post(AppConfig.apiurl+'/api/deletefeature', payload, { headers: AuthHeader.header })
     .then( response => {       
         if(response.status==200){ 
            var resdata=response.data;
            if(resdata.status===1){
               allFeatures()(dispatch);
               NotificationManager.success(resdata.message);               
               dispatch({ type: DELETE_FEATURE });
            }else{
               NotificationManager.error(resdata.message); 
            }
         }            
         
     })
     .catch( error => { 
       NotificationManager.error(error);
     });
}

export const allMenus = () =>{    
    
   return (dispatch) => { 
       dispatch({ type: MENU_ACTION });
       return axios.get(AppConfig.apiurl+'/api/getmenu', { headers: AuthHeader.header })         
       .then(response => {             
           const allroles=response.data.data;
           dispatch({ type: ALL_MENUS, payload: allroles });
       });
  }
}

export const addMenu = (name,stdrole) => async (dispatch) => {
   
   var payload={
       "name":name,
       "stdrole":stdrole
    }
    dispatch({ type: MENU_ACTION });
   axios.post(AppConfig.apiurl+'/api/addmenu', payload, { headers: AuthHeader.header })
    .then( response => {       
        if(response.status==200){ 
           var resdata=response.data;
           if(resdata.status===1){
              allMenus()(dispatch);
              NotificationManager.success(resdata.message);               
              dispatch({ type: ADD_MENU });
           }else{
              NotificationManager.error(resdata.message); 
           }
        }else{
           NotificationManager.error('Menu not added');
        }            
        
    })
    .catch( error => { 
      NotificationManager.error(error);
    });
}

export const editMenu = (name,stdrole, display, id) => async (dispatch) => {
   
   var payload={
       "id":id,
       "name":name,
       "roleid":stdrole,
       "display":display
    }
    dispatch({ type: MENU_ACTION });
   axios.post(AppConfig.apiurl+'/api/editmenu', payload, { headers: AuthHeader.header })
    .then( response => {       
        if(response.status==200){ 
           var resdata=response.data;
           if(resdata.status===1){
              allMenus()(dispatch);
              NotificationManager.success(resdata.message);               
              dispatch({ type: EDIT_MENU });
           }else{
              NotificationManager.error(resdata.message); 
           }
        }            
        
    })
    .catch( error => { 
      NotificationManager.error(error);
    });
}

export const statusMenu = (id,status) => async (dispatch) => {
   
   var payload={
       "id":id,
       "status":status
    }
    dispatch({ type: MENU_ACTION });
   axios.post(AppConfig.apiurl+'/api/statusmenu', payload, { headers: AuthHeader.header })
    .then( response => {       
        if(response.status==200){ 
           var resdata=response.data;
           if(resdata.status===1){
              allMenus()(dispatch);
              NotificationManager.success(resdata.message);               
              dispatch({ type: STATUS_MENU });
           }else{
              NotificationManager.error(resdata.message); 
           }
        }            
        
    })
    .catch( error => { 
      NotificationManager.error(error);
    });
}

export const deleteMenu = (id) => async (dispatch) => {
   
   var payload={
       "id":id
    }
    dispatch({ type: MENU_ACTION });
   axios.post(AppConfig.apiurl+'/api/deletemenu', payload, { headers: AuthHeader.header })
    .then( response => {       
        if(response.status==200){ 
           var resdata=response.data;
           if(resdata.status===1){
              allMenus()(dispatch);
              NotificationManager.success(resdata.message);               
              dispatch({ type: DELETE_MENU });
           }else{
              NotificationManager.error(resdata.message); 
           }
        }            
        
    })
    .catch( error => { 
      NotificationManager.error(error);
    });
}



